module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1-1"
    }
  }, [_c('p', {
    staticClass: "chapterNumberC"
  }, [_c('span', {
    staticClass: "t19"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")])]), _c('span', {
    staticClass: "smallcaps"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HAPTER")])]), _vm._v(" "), _c('span', {
    staticClass: "t19"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterTitleC"
  }, [_c('span', {
    staticClass: "t12"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Militia Major Killed in a Duel")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterYearC"
  }, [_c('span', {
    staticClass: "t21"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1806")])])]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndentTB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("… their animosity increased daily …")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_c('img', {
    staticClass: "dropcap",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "images",
      "src": "images/imgO.jpg"
    }
  })]), _vm._v("n a December day in 1806, just before Christmas, Colonel Bolton of the Loyal Liverpool Volunteers, stood firm on the ground where he was to fight a duel with Edward Brookes. He calmly said to his opponent, ‘Agreeably to the custom of duelling, I believe that you, Sir, are to fire first.’ Brookes, a major in the Lancashire Militia in former times, did indeed fire first, but missed his man. Bolton took aim, fired and in seconds, his opponent was down on the grass, the ball penetrating his skull, just above his right eye. The man’s seconds and the medical attendant came quickly but the major was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A good shot had killed a poor shot: a sad scene all too common in military history throughout the centuries. This rapid and merciless method of satisfying a debt of honour had given the Liverpool undertakers another customer in officer’s garb.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bolton wasted no time in removing himself from the scene. His friends had a carriage ready. As the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Annual Register")]), _vm._v(" reported: ‘Since then he has not been heard of.’ This was wilful murder in the criminal law, but here is the problem at that time in history: it was a military matter, often related to regimental pride and honour. The law of the land was often at odds with army thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fighting a duel over a matter of honour had always been a principle element of British military life up to the Regency period, and such combats presented problems. This Liverpool case was no different. A war was being fought in Europe at the time against Napoleon of course; the military men were used to hard living, and their habits were carried over into civilian life. Army regulations stated that a man must defend his honour. Only three years before Bolton’s killing of Brookes, a Captain Macnamara in the Royal Navy had killed a man in a duel and his defence was that ‘he needed to sustain his character for courage.’ He was acquitted. There had been a law passed in 1803, and known as Lord Ellenborough’s Act, which made duelling a capital offence; if one participant was killed, then the charge was murder. But a law on the Statute Book is one thing: actual convention and army practice is another.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e44f41a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_ch11.vue
// module id = 75
// module chunks = 0